export const CssVariables = {
    headerHeight: '3.5rem',

    masterDetailsAsideWidth: '31rem',
};

export const CssColors = {
    black: '#1d1d1f',
    white: '#ffffff',
    mainGreen: '#3FE579',
    secondaryGreen: '#9CE4A3',
    mainRed: '#F33F4A',
    gray: '#737373',
    mainGray: '#9B9BA4',
    inputBorderColor: '#D2D2D7',
    mainYellow: '#E3DB40',
    buttonBgHover: '#1d1d1fa6',
    // Design system (PRD) — color names only
    textBlack: '#000000',
    textWhite: '#FFFFFF',
    borderLightGrey: '#E5E7EB',
    borderMediumGrey: '#EDEBEB',
    fillWhite: '#FFFFFF',
    fillGrey: '#EDEBEB',
    red: '#EF4444',
    green: '#16A34A',
    pureBlack: '#000000',
};
